import helpCenter from "@/components/saas/help.vue";
import helpBtn from "@/components/saas/helpBtn.vue";
export default {
  components: {
    helpCenter,
    helpBtn,
  },
  data() {
    return {
      isHelp: false,
    };
  },
  methods: {
    showCenter() {
      this.isHelp = true;
    },
    hideCenter() {
      this.isHelp = false;
    },
  },
};


// WEBPACK FOOTER //
// ./src/mixins/helpCenter.js